import { render, staticRenderFns } from "./web-set-email.vue?vue&type=template&id=db35966a&scoped=true&"
import script from "./web-set-email.vue?vue&type=script&lang=js&"
export * from "./web-set-email.vue?vue&type=script&lang=js&"
import style0 from "./web-set-email.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./web-set-email.vue?vue&type=style&index=1&id=db35966a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db35966a",
  null
  
)

export default component.exports